import React from "react";

function PageHeader({
    title,
    className = "",
    titleClassName = "",
    children = null,
    rightSlot = null,
}) {
    const headerClasses = ["border_title", className].filter(Boolean).join(" ");
    const resolvedTitleClassName = ["page-header-title", titleClassName].filter(Boolean).join(" ");

    return (
        <div className={headerClasses}>
            <div className="page-header-row">
                <h2 className={resolvedTitleClassName}>{title}</h2>

                {rightSlot ? (
                    <div className="page-header-side page-header-side-right">
                        {rightSlot}
                    </div>
                ) : null}
            </div>

            {children ? <div className="page-header-extra">{children}</div> : null}
        </div>
    );
}

export default PageHeader;
